import { render } from "./company-notification-summary.vue?vue&type=template&id=105d3499&ts=true"
import script from "./company-notification-summary.vue?vue&type=script&lang=ts"
export * from "./company-notification-summary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__